import { ALL_ROLES, RoleName } from './user.service';

/** Issue #88: per-role icon (files under assets/icons/). CUSTOMER and CREATOR share the plain user icon. */
const ROLE_ICONS: Record<RoleName, string> = {
  CUSTOMER: 'user',
  CREATOR: 'user',
  TEAMBOARD: 'user-teamboard',
  TEAM: 'user-team',
  DRIVER: 'user-driver',
  COLLECTOR: 'user-collector',
  OFFICER: 'user-officer',
  PLANNER: 'user-planner',
  CONTROLLER: 'user-controller',
  MANAGER: 'user-manager',
  ADMIN: 'user-admin'
};

export function roleIcon(role: RoleName): string {
  return ROLE_ICONS[role];
}

/** The icon of the highest-ranked role (ALL_ROLES is ordered by ascending role_order), for users with several. */
export function highestRoleIcon(roles: readonly string[]): string | null {
  const ranked = ALL_ROLES.filter(role => roles.includes(role));
  return ranked.length > 0 ? ROLE_ICONS[ranked[ranked.length - 1]] : null;
}
